<div (click)="$event.stopPropagation()">
  <input
    type="text"
    pInputText
    [placeholder]="placeholder"
    [formControl]="formControl"
    (input)="onInputChange($event, overlayRef)"
    (focus)="onFocus($event, overlayRef)"
    (blur)="onBlur()"
    class="w-full"
  />

  <p-overlayPanel #overlayRef [dismissable]="true">
    <div *ngIf="noResultsMessage" class="text-gray-500 p-2">
      {{ noResultsMessage }}
    </div>

    <ul *ngIf="searchResults.length > 0" class="list-none m-0 p-0">
      <li
        *ngFor="let item of searchResults"
        (click)="selectOption(item, overlayRef)"
        style="cursor: pointer; padding: 4px;"
        class="border-bottom-1 border-gray-200 hover:bg-gray-100"
      >
        {{ item.port_name || item.label }}
      </li>
    </ul>
  </p-overlayPanel>
</div>
